/**
 * Screens that follow the chosen language (saved choice, then the Genesys
 * language, then English). Confirm dialogs opened from one of these screens
 * follow it too, because they translate while that screen is showing.
 * Page names match `Page` in App.tsx.
 */
export const TRANSLATED_SCREENS = [
  'landing',
  'actions',
  'settings',
  'signin',
  'loading',
  'error',
] as const;

/**
 * Install steps, Setup Complete and uninstall stay English and left-to-right
 * even when a language is chosen.
 */
export const ENGLISH_ONLY_SCREENS = [
  'welcome',
  'setup',
  'install-summary',
  'provisioning',
  'complete',
  'uninstalling',
] as const;

const TRANSLATED = new Set<string>(TRANSLATED_SCREENS);

export function screenFollowsLanguage(page: string): boolean {
  return TRANSLATED.has(page);
}
